import React from 'react';
import AsyncSelect from 'react-select/async';
import PropTypes from 'prop-types';

import { searchProperties } from './api';

const Option = (props) => {
  const { innerProps, innerRef } = props;
  return (
    <div ref={innerRef} {...innerProps} className="contact-select">
      <div className='p-2 clickable border-bottom'>
        <strong>{props.label}</strong>
        <small className='pull-right'>Source: {props.data.database}</small>
      </div>
    </div>
  );
};

export default class ResearchPropertySelector extends React.Component {
  static propTypes = {
    placeholder: PropTypes.string,
    onModelAdded: PropTypes.func.isRequired
  };

  state = {
    value: ''
  }

  loadResearchPropertyOptions = (inputValue, callback) => {
    searchProperties(inputValue, { serializationLevel: 'rprop_simple_search' }).then((properties) => {
      const options = properties.map((property) => {
        return { value: property.id, label: property.displayName, database: property.databaseName, property };
      });
      callback(options);
    });
  }

  onSelected = (selection) => {
    this.setState({
      value: selection
    });
    this.props.onModelAdded(selection);
  }

  render() {
    return (
      <AsyncSelect
        autoFocus
        components = {{ Option }}
        loadOptions={this.loadResearchPropertyOptions}
        placeholder={this.props.placeholder || 'Search Properties ...'}
        value={this.state.value}
        onChange={this.onSelected}
      />
    );
  }
}
